var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_20312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2334 18L30 23.7734L26.7666 18H16L30 43L44 18H33.2334Z",
    fill: "#4DBA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.233 18L29.9996 23.7734L26.7662 18H21.5996L29.9996 32.9993L38.3996 18H33.233Z",
    fill: "#435466"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_20312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 25,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow17);
export default __webpack_public_path__ + "static/media/row-1-7.07ff90cf7a2522e77dc84548e9c9d22f.svg";
export { ForwardRef as ReactComponent };